import { call, put, takeLatest } from "redux-saga/effects";
import types from "./types";
import apiClientFactory from "../../backend/apiClient";
import endPoint from "../../backend/endpoints";

//get
function* getPublicFormBuilderHandlerSaga(action) {
	console.log("Hello from public form saga");
	const apiClient = apiClientFactory();
	try {
		const { data } = yield call(
			apiClient.get,
			endPoint.publicFromList(action.payload),
		);
		yield put({
			type: types.GET_PUBLICFORMLIST_SUCCESS,
			payload: data.response,
		});
	} catch (e) {
		const payload = e?.response?.data || e;
		yield put({
			type: types.GET_PUBLICFORMLIST_ERROR,
			payload,
		});
	}
}

export function* getPublicProfileFormBuilderWatcherSaga() {
	yield takeLatest(
		types.GET_PUBLICFORMLIST_START,
		getPublicFormBuilderHandlerSaga,
	);
}

//get/id

//create
